import { AgentInfo, ActCurrent } from '@/config/types';

export const formatAgentQuantity = (agents: Array<AgentInfo>) => {
  if (!agents || !agents.length) return '';
  const length = agents.length === 1 ? '' : `(+${agents.length - 1})`;
  return `${agents[0].name} ${length}`;
};

export const formatStatusAct = (actCurrent: ActCurrent) => {
  if (!actCurrent) return 'INATIVA';
  return 'ATIVA';
};
